var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showApplicationLoader, hideApplicationLoader, } from 'common/ApplicationLoader';
import { showToast } from 'common/Toast';
import { showError } from 'store/commonReducer/common.action';
import { getKeySeniorInfoService, updateKeySeniorInfoService, } from './KeySeniorInfo.service';
export var SET_KEY_SENIOR_INFO = 'SET_KEY_SENIOR_INFO';
/**
 * @function getKeySeniorInfo
 * @description action to get key senior note
 */
export var getKeySeniorInfo = function () {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, user_id, account_id, response, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = getState().common.seniorDetail.minimalInfo, user_id = _a.user_id, account_id = _a.account_id;
                    dispatch(showApplicationLoader());
                    return [4 /*yield*/, getKeySeniorInfoService({
                            senior_id: user_id,
                            account_id: account_id,
                        })];
                case 1:
                    response = _b.sent();
                    dispatch({
                        type: SET_KEY_SENIOR_INFO,
                        payload: {
                            keySeniorInfo: response,
                        },
                    });
                    dispatch(hideApplicationLoader());
                    // IMPORTANT
                    return [2 /*return*/, response];
                case 2:
                    error_1 = _b.sent();
                    dispatch(hideApplicationLoader());
                    dispatch(showError(error_1));
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function updateKeySeniorInfo
 * @description action to create/update key senior note
 */
export var updateKeySeniorInfo = function (keyMemberNote) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, user_id, account_id, userId, payload, response, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = getState().common.seniorDetail.minimalInfo, user_id = _a.user_id, account_id = _a.account_id;
                    userId = getState().auth.userId;
                    dispatch(showApplicationLoader());
                    payload = {
                        senior_id: user_id,
                        account_id: account_id,
                        careagent_id: userId,
                        key_member_note: keyMemberNote,
                    };
                    return [4 /*yield*/, updateKeySeniorInfoService(payload)];
                case 1:
                    response = _b.sent();
                    dispatch({
                        type: SET_KEY_SENIOR_INFO,
                        payload: { keySeniorInfo: response.data },
                    });
                    dispatch(hideApplicationLoader());
                    dispatch(showToast((response === null || response === void 0 ? void 0 : response.message) || 'Key member note updated successfully', 'success'));
                    return [2 /*return*/, { success: true, data: response.data }];
                case 2:
                    error_2 = _b.sent();
                    dispatch(hideApplicationLoader());
                    dispatch(showError(error_2));
                    dispatch(showToast('Something Went Wrong!', 'error'));
                    return [2 /*return*/, { success: false }];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
